import React from "react";
import styled from "styled-components";
import DPCheckCard from "./DPCheckCard";
import useImageCheck from "../hooks/useImageCheck";

const DPCardCheckGroup = ({
  data,
  onClick,
  onChange,
  value = [],
  showCheckbox = false,
  disabled,
  id,
}) => {
  const { handleChange } = useImageCheck({
    onChange,
    value,
  });

  return (
    <DpCardContainer id={id}>
      {data.length > 0 ? (
        data.map((item, index) => (
          <DPCheckCard
            key={index}
            city={item.city}
            id={item.fe_id}
            matchPercentage={item.match_score}
            image={item.profile_pic_url}
            onClick={() => onClick(index, item)}
            onChange={(val) => handleChange(item.fe_id, val)}
            value={value?.includes(item.fe_id)}
            showCheckbox={showCheckbox}
            disabled={disabled}
          />
        ))
      ) : (
        <NoResults>No data available</NoResults>
      )}
    </DpCardContainer>
  );
};

export default DPCardCheckGroup;

export const DpCardContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;
`;

export const NoResults = styled.div`
  width: 100%;
  height: 100%;
  font-size: 16px;
  color: #b0b0b0;
`;
